import React from "react";
import getSymbolFromCurrency from "currency-symbol-map";
import { useIframeSettings } from "../../../../../_helpers/IframeSettingsContext";
import { Field } from "formik";

export const PriceLab = (props) => {
    const { currency } = useIframeSettings();
    function Currency(){
        const cur = currency || (props.themeData && props.themeData.api_currency)
        return getSymbolFromCurrency(cur) || ""
    }

    return (
        <>
            <div className="row mt-5 pb-8 border-bottom">
                <div className="col-lg-2">
                    <p className="font-size-h6">{props.language.CCMODE_THEME1_SEARCHDIAMOND_PRICE}</p>
                </div>
                <div className="col-lg-10">
                    <div className="row">
                        {/* <div className="col-md-6 d-flex align-items-end">
                            <div className="form-group mb-0 w-100 mr-2">
                                <label>{Currency()}/CT</label>
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Min_Rate"
                                        min="0"
                                        id="Min_Rate"
                                        placeholder="From"
                                        autoComplete="off"
                                    />
                                    <div className="input-group-append"><span className="input-group-text">{Currency()}</span></div>
                                </div>
                            </div>
                            <div className="form-group mb-0 w-100">
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Max_Rate"
                                        min="0"
                                        id="Max_Rate"
                                        placeholder="To"
                                        autoComplete="off"
                                    />
                                    <div className="input-group-append"><span className="input-group-text">{Currency()}</span></div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-6 d-flex align-items-end">
                            <div className="form-group mb-0 w-100 mr-2">
                                <label>Price</label>
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Min_Price"
                                        min="0"
                                        step="0.01"
                                        id="Min_Price"
                                        placeholder="From"
                                        autoComplete="off"
                                    />
                                    <div className="input-group-append"><span className="input-group-text">{Currency()}</span></div>
                                </div>
                            </div>
                            <div className="form-group mb-0 w-100">
                                <div className="input-group">
                                    <Field
                                        className="form-control"
                                        type="number"
                                        name="Max_Price"
                                        min="0"
                                        step="0.01"
                                        id="Max_Price"
                                        placeholder="To"
                                        autoComplete="off"
                                    />
                                    <div className="input-group-append"><span className="input-group-text">{Currency()}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
